var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0101 17.7771C46.0101 11.6406 51.0073 6.66602 57.1717 6.66602C63.3361 6.66602 68.3333 11.6406 68.3333 17.7771C68.3333 23.9136 63.3361 28.8882 57.1717 28.8882C54.059 28.8882 51.2459 27.6192 49.2236 25.5776L33.7722 36.0979C33.915 36.8076 33.9899 37.5409 33.9899 38.29C33.9899 39.7734 33.6968 41.1913 33.1653 42.4872L50.1077 53.6187C52.0305 52.0529 54.491 51.1105 57.1717 51.1105C63.3361 51.1105 68.3333 56.0851 68.3333 62.2216C68.3333 68.3581 63.3361 73.3327 57.1717 73.3327C51.0073 73.3327 46.0101 68.3581 46.0101 62.2216C46.0101 60.6143 46.3541 59.0844 46.9724 57.7031L30.1669 46.6617C28.2065 48.3655 25.6386 49.4011 22.8282 49.4011C16.6639 49.4011 11.6666 44.4265 11.6666 38.29C11.6666 32.1535 16.6639 27.1788 22.8282 27.1788C26.373 27.1788 29.5284 28.8235 31.5715 31.3833L46.5464 21.1874C46.198 20.1113 46.0101 18.9647 46.0101 17.7771Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectUs);
export default __webpack_public_path__ + "static/media/connect-us.8301dcca99ad4af47cf950228b233f43.svg";
export { ForwardRef as ReactComponent };